<template>
	<div class="parameter-wrap"  :style="txtStyle" @touchstart="_touchStart" @touchmove="_touchMove" @touchend="_touchEnd" ref="wrap">
		<mu-infinite-scroll :loading="load" loadingText="拼命加载中" class="load" v-if="load"/>
		<div ref="content">
		    <empty  emptytext="对不起，暂时没有找到结果" v-if="GoodsKindValue.length<1 && !load"></empty>
			<div class="parameter-box" v-for="item in GoodsKindValue">
				<h3 class="header">{{item.groupName}}</h3>
				<div class="parameter-item" v-for="sub in item.values">
					<label class="label">{{sub.fieldName}}</label>
					<span class="content">{{sub.fieldValue}}</span>
				</div>
			</div>
			<div class="tripartite-box" v-show="height>0"  :style="txtStyle">
				<span class="wxauth-title">
					{{tip}}
				</span>
			</div>
		</div>
		
	</div>
</template>
<script type="text/javascript">
	import {mapActions,mapGetters} from 'vuex';
	import empty from '@components/empty/empty';
	export default{
		data(){
			return{
				tip:'继续拖动，查看评价',
				startY: 0,       //触摸位置
                moveY: 0,       //滑动时的位置
                disY: 0,       //移动距离
                txtStyle: '',
                height:0,
                startScrollH:0,//开始滑动  记录当前滚动的位置


                goodsId:this.$route.query.goodsId || this.$route.query.linkTarget,//商品id
                storeId:this.$route.query.storeId || '',//商品id
                skuId:this.$route.query.skuId || 0, //商品id


				load:true,
				GoodsKindValue:'',
			}
		},
		mounted() {
			let count=0;
			this.yzInterval = setInterval(() => {
	        	count++;
	        	if(this.load == false){
	        		clearInterval(this.yzInterval);
	        		let cHeight = this.$refs.wrap.clientHeight;//元素的高度
					let oHeight  = this.$refs.content.clientHeight;//内容的高度
					this.height = oHeight - cHeight;//可滑动的最大值
	        	}
	      	}, 1000);
		},
		computed:{
		    ...mapGetters({
		       scrollHeight:'scrollHeight'
		    })
		},
		methods:{
            ...mapActions({
                 getGoodsKindValue:'getGoodsKindValue',//获取商品SKU信息
            }),
            //18.2.获取商品详情
            getGoodsKind(id){
                this.getGoodsKindValue([id]).then(res=>{
                   this.GoodsKindValue = res;
                   this.load = false;
                })
            },
            _touchStart: function(ev) {
                ev = ev || event;
                if(ev.touches.length == 1){
                    // 手指按下的时候记录按下的位置
                    this.startY = ev.touches[0].clientY;
                    //记录手指按下时滚动的高度
                    this.startScrollH = this.scrollHeight.scrollHeight ;
                }
            },
            _touchMove: function(ev) {
                ev = ev || event;
                if(ev.touches.length == 1) {
                    // 滑动过程中的实时位置
                    this.moveY = ev.touches[0].clientY
                    // 滑动过程中实时计算滑动距离
                    this.disY = this.startY - this.moveY;
                    //console.log('disY==>', this.disY,this.height, this.startScrollH)
                    //鼠标按下时的滑动距离大于可滑动的最大距离  
                    if ( this.startScrollH/this.height >= 0.98) {
                    	if(this.disY > 100 ){
	                   		//滑动距离大于100
	                        // this.txtStyle = "transform:translateY(-" + this.disY + "px)";
	                        this.txtStyle = "margin-bottom:" + this.disY + "px";
	                        document.getElementById('dishesWrapper').scrollTop = this.scrollHeight.scrollHeight  + this.disY;
	                        this.tip = '释放切换到评价'
	                    }else if(this.disY > 0 && this.disY < 100){
                    		this.txtStyle = "margin-bottom:" + this.disY + "px";
                    		document.getElementById('dishesWrapper').scrollTop = this.scrollHeight.scrollHeight  + this.disY;
	                        this.tip = '上拉切换到评价'
	                        //this.tip = '继续拖动，查看详情'
	                    }
	                }else{
	                	this.tip = '继续拖动，查看评价'
	                }
	            }
            },
            _touchEnd: function(ev) {
                if (event.changedTouches.length == 1) {
                    // 手指移动结束后的水平位置
                    let endX = event.changedTouches[0].clientY;
                    // 触摸开始与结束,手指移动的距离
                    //this.disY = this.startY - endX;
                    //如果距离小于100，页面不跳转，否则跳转至对应页面
                    //console.log("=>",this.disY,this.height, this.startScrollH)
                     //滑动结束，判断当前的滑动距离大于或等于时 偏移
                    if (this.disY > 100 &&  this.startScrollH/this.height >= 0.98) {
                     	this.$router.push({path: '/main/goodsDetail/evaluate?goodsId='+ this.goodsId + '&storeId='+ (this.storeId || '')+'&skuId=' + this.skuId});
                     }else{
	                 	this.txtStyle = "margin-bottom:" + 0 + "px";
	                 	document.getElementById('dishesWrapper').scrollTop = this.scrollHeight.scrollHeight;
	                 	this.tip = '继续拖动，查看评价';
	                 }
                 } 
            },
        },
		components:{
			empty,
		},
		created(){
			this.load = true;
			this.getGoodsKind(this.$route.query.goodsId);
		}
	}
</script>
<style lang="scss" rel="stylesheet/scss">
	@import 'src/common/sass/mixin.scss';
	.parameter-wrap{
		height: 100%;
		background: #fff;
		@include font-dpr(14px);
		.parameter-box{
			padding: 0.4rem 0.35rem;
			>h3.header{
				padding-bottom: 0.5rem;
				color: 000000;
			}
			.parameter-item{
				margin-bottom: 0.125rem;
			}
			.label,.content{
				line-height: 1.5;
				display: inline-block;
			}
			.label{
				width: 2.25rem;
				color: #999999;
			}
			.content{
				display: -webkit-inline-box;
				margin-left: 0rem;
				margin-top: -0.475rem;
				color: #333333;
			}
		}
		.tripartite-box{
			text-align: center;
			padding:0.5rem 0rem;
			.wxauth-title{
				color: #999;
				@include font-dpr(14px);
				padding: 0 3rem;
				position: relative;
				&:before,&:after{
					content: "";
					display: inline-block;
					width: 2.5rem;
					height: 1px;
					position: absolute;
					top: 50%;
					background: #E5E5E5;
				}
				&:before{
					left: 0;
				}
				&:after{
					right: 0;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// parameter.vue?43db4817